@import "tailwindcss";
@import "tw-animate-css";
@import "vue-sonner/style.css";

/*
 * Design tokens (palette, semantic colours, light/dark values, brand gradient,
 * border-colour base reset) live in tokens.css — the single source of truth
 * shared byte-for-byte with the React mirror package. Edit tokens THERE.
 * See resources/css/tokens.css.
 */
@import "./tokens.css";

/*
 * Menu/menuStyles.ts's menuPanelHeightClass()/menuPanelOriginClass() BUILD their
 * class strings by interpolation (`max-h-(${var})`) rather than as source
 * literals — required for one function to serve DropdownMenu's and ContextMenu's
 * different reka CSS var names. Tailwind's scanner only detects literal candidate
 * strings, so a purely-interpolated class is invisible to it and the utility is
 * never generated.
 *
 * These utilities currently resolve only BY ACCIDENT: the literals happen to
 * appear in the vendored ui/dropdown-menu and ui/context-menu Content files. Once
 * those are deleted (they have no importers left), the accident ends and every
 * menu panel silently loses its max-height clamp — no error, just an unbounded
 * panel. That exact failure was caught in the React mirror, which had no such
 * accidental literal to lean on.
 *
 * @source inline(...) force-generates the utilities the interpolation can
 * produce, independent of any literal occurrence. Mirrors the same block in
 * packages/design-system-react/src/styles.css (radix var names there).
 * ContextMenu has no origin var: it anchors to the cursor, so reka never emits a
 * transform-origin for it.
 */
@source inline("max-h-(--reka-dropdown-menu-content-available-height)");
@source inline("origin-(--reka-dropdown-menu-content-transform-origin)");
@source inline("max-h-(--reka-context-menu-content-available-height)");

@plugin "@tailwindcss/forms";

body{
    margin-bottom: 0 !important;
}

/* App-specific layout-utility extensions (not design tokens). */
@theme {
  --max-width-1\/2: 50%;
  --min-width-72: 18rem;
  --max-height-cmax: 25.3rem;
}

/* Guest page entrance animations */
@keyframes guest-fade-in-down {
  from {
    opacity: 0;
    transform: translateY(-24px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes guest-fade-in-up {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes guest-stagger-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mesh background drift animations */
@keyframes mesh-drift-1 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(30px, -40px); }
  50% { transform: translate(-20px, 20px); }
  75% { transform: translate(40px, 30px); }
}

@keyframes mesh-drift-2 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-40px, 30px); }
  50% { transform: translate(30px, -20px); }
  75% { transform: translate(-20px, -40px); }
}

@keyframes mesh-drift-3 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(40px, 20px); }
  50% { transform: translate(-30px, -30px); }
  75% { transform: translate(20px, -20px); }
}

@media (prefers-reduced-motion: reduce) {
  .guest-animate-logo,
  .guest-animate-card,
  .guest-animate-stagger {
    animation: none !important;
    opacity: 1 !important;
  }
  .guest-orb {
    animation: none !important;
  }
}

@layer base {
  body {
    @apply bg-background text-foreground;
  }
  :root {
    --sidebar-background: var(--sidebar);
    --sidebar-foreground: 240 5.3% 26.1%;
    --sidebar-primary: 240 5.9% 10%;
    --sidebar-primary-foreground: 0 0% 98%;
    --sidebar-accent: 240 4.8% 95.9%;
    --sidebar-accent-foreground: 240 5.9% 10%;
    --sidebar-border: 220 13% 91%;
    --sidebar-ring: 217.2 91.2% 59.8%;
 }

  .dark {
    --sidebar-background: 240 5.9% 10%;
    --sidebar-foreground: 240 4.8% 95.9%;
    --sidebar-primary: 224.3 76.3% 48%;
    --sidebar-primary-foreground: 0 0% 100%;
    --sidebar-accent: 240 3.7% 15.9%;
    --sidebar-accent-foreground: 240 4.8% 95.9%;
    --sidebar-border: 240 3.7% 15.9%;
    --sidebar-ring: 217.2 91.2% 59.8%;
  }
}
